import { render, staticRenderFns } from "./Destacados_Comp.vue?vue&type=template&id=422817ed&scoped=true&"
import script from "./Destacados_Comp.vue?vue&type=script&lang=js&"
export * from "./Destacados_Comp.vue?vue&type=script&lang=js&"
import style0 from "./Destacados_Comp.vue?vue&type=style&index=0&id=422817ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422817ed",
  null
  
)

export default component.exports